<template>
    <p>
        Para obter os dados de pagamento desta parcela,
        <a
            href="https://nuapp.nubank.com.br/bnVhcHA6Ly9jcmVkaXQtY2FyZC9iaWxsLXBheW1lbnQ="
            target="_blank"
            rel="noopener"
            @click="handleClick"
        >clique aqui</a>
        e acesse o portal do Nubank.
    </p>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IPromessa } from '@/models/IPromessa';
import { acertoClickAcessarAplicativo } from '@/modules/events/acerto';

export default defineComponent({
  name: 'CompMsgEmissaoParcelaSuspensa',
  props: {
    proposta: { type: Object as PropType<IPromessa>, required: true },
  },
  setup(props) {
    const handleClick = () => {
      acertoClickAcessarAplicativo(props.proposta);
    };

    return {
      handleClick,
    };
  },
});
</script>

<style scoped>
a {
    color: inherit;
    text-decoration: underline;
}

a:hover {
    text-decoration: none;
}
</style>
